import { Link } from "react-router-dom";
import { postBySlug } from "@/data/blog";
import { SEA_MOSS_IODINE } from "@/data/singles";

export const iodineLine = (id, w) => (w === SEA_MOSS_IODINE ? <IodineLink id={id} /> : null);

export const SEA_MOSS_IDS = ["sea-moss", "sea-moss-2-pack"];
const ODS = "https://ods.od.nih.gov/factsheets/Iodine-Consumer/";
const ROWS = [["Irish moss (Chondrus crispus)", "500 mg"], ["Bladderwrack (Fucus vesiculosus)", "500 mg"], ["Burdock root", "400 mg"], ["BioPerine® black pepper extract", "5 mg"]];
const FOOT = { "sea-moss": "30 servings · 60 capsules per bottle · Capsule: pullulan", "sea-moss-2-pack": "2 bottles · 60 capsules each · 30 servings per bottle · Capsule: pullulan" };
const RELATED = [["how-to-take-sea-moss", "How to take sea moss"], ["sea-moss-gel-vs-capsules", "Sea moss gel vs capsules"]];
const link = "font-semibold underline decoration-sunny decoration-2 underline-offset-4";

export const IodineLink = ({ id }) => (
  <> Learn more: <a href={ODS} target="_blank" rel="noopener noreferrer" data-testid={`iodine-ods-link-${id}`} className={`${link} break-all`}>{ODS}</a></>
);

export const SeaMossFacts = ({ id }) => (
  <div data-testid={`sea-moss-facts-${id}`} className="mt-6 rounded-3xl bg-white border-2 border-navy p-5">
    <p className="font-display text-lg">Supplement Facts</p>
    <p className="mt-1 text-sm text-slate-600">Amounts per 2-capsule serving</p>
    <table className="mt-3 w-full text-sm">
      <thead><tr className="border-b-2 border-navy text-left"><th className="py-1.5">Ingredient</th><th className="py-1.5 text-right">Per 2 capsules</th></tr></thead>
      <tbody>
        {ROWS.map(([n, a]) => <tr key={n} className="border-b border-navy/15"><td className="py-1.5 pr-3">{n}</td><td className="py-1.5 text-right whitespace-nowrap">{a}</td></tr>)}
        <tr className="font-bold"><td className="py-1.5">Total</td><td className="py-1.5 text-right" data-testid={`sea-moss-total-${id}`}>1,405 mg</td></tr>
      </tbody>
    </table>
    <p data-testid={`sea-moss-facts-foot-${id}`} className="mt-3 text-xs text-slate-600">{FOOT[id]}</p>
  </div>
);

export const SeaMossDirections = ({ id }) => (
  <div data-testid={`sea-moss-directions-${id}`} className="mt-6 sticker-sm bg-white p-5 text-sm">
    <p className="font-display text-lg">Directions</p>
    <p className="mt-2">Take 2 capsules daily, as directed on the label. Label: "Suggested use: 2 capsules once daily (30 servings, 60 capsules)."</p>
  </div>
);

const Faq = ({ id, related }) => [
  ["What's in Grandpa Finn's Sea Moss?", "Per 2-capsule serving: Irish moss 500 mg, bladderwrack 500 mg, burdock root 400 mg and BioPerine® black pepper extract 5 mg, in pullulan capsules. 60 capsules, 30 servings."],
  ["How do I take it?", "Take 2 capsules daily, as directed on the label (\"2 capsules once daily\"). Don't take more than the label says."],
  ["Capsules or sea moss gel?", <>Gel is soaked and blended seaweed kept in the fridge and measured by the spoon. Capsules are a set amount per serving with no prep.{related.gel && <> Read more: <Link to="/blog/sea-moss-gel-vs-capsules" data-testid={`faq-gel-link-${id}`} className={link}>Sea moss gel vs capsules</Link>.</>}</>],
  ["Does it contain iodine?", "Seaweed naturally contains iodine, and amounts vary. This label doesn't list an iodine amount. The NIH ODS adult upper limit is 1,100 mcg a day from all sources. Ask your doctor if you're unsure."],
];

export const SeaMossFaq = ({ id }) => {
  const live = RELATED.filter(([s]) => postBySlug(s));
  const items = Faq({ id, related: { gel: !!postBySlug("sea-moss-gel-vs-capsules") } });
  return (
    <>
      <div data-testid={`sea-moss-faq-${id}`} className="mt-6 sticker-sm bg-white p-5">
        <p className="font-display text-lg">FAQ</p>
        <dl className="mt-2 space-y-3 text-sm">
          {items.map(([q, a], i) => <div key={q}><dt data-testid={`sea-moss-faq-q-${id}-${i + 1}`} className="font-bold">{q}</dt><dd className="mt-1 text-slate-700">{a}</dd></div>)}
        </dl>
      </div>
      {live.length > 0 && (
        <div data-testid={`sea-moss-related-${id}`} className="mt-6 text-sm">
          <p className="font-display text-lg">Related reading</p>
          <ul className="mt-2 list-disc pl-5 space-y-1">{live.map(([s, t]) => <li key={s}><Link to={`/blog/${s}`} data-testid={`related-link-${s}`} className={link}>{t}</Link></li>)}</ul>
        </div>
      )}
    </>
  );
};
